import { FC, memo, PropsWithChildren } from "react";

import { useRouter } from "next/router";

import { useLogRouteChangePageVisits, RouteType } from "@/common/hooks/amplitude/useLogRouteChangePageVisits";

const PublicRouteToMemoized: FC<PropsWithChildren> = ({ children }) => {
  const router = useRouter();
  useLogRouteChangePageVisits({ path: router.pathname, routeType: RouteType.PublicRoute });

  return <>{children}</>;
};

export const PublicRoute = memo(PublicRouteToMemoized);
